/** @format */

import {styled} from '@mui/material/styles';
import {Box, Button, Typography} from '@mui/material';

interface ActiveProps {
  active: boolean;
}

export const Root = styled(Box, {
  shouldForwardProp: prop => prop !== 'active',
})<ActiveProps>(({theme, active}) => ({
  display: 'grid',
  gridTemplateColumns: '24px 1fr 16px',
  alignItems: 'center',
  gap: theme.spacing(2),
  padding: theme.spacing(0, 1.5, 0, 2),
  background: active
    ? theme.palette.figma_gray_light_4?.main
    : theme.palette.figma_gray_dark_4?.main,
  width: '100%',
  height: '48px',
  transition: '0.2s',

  '&:hover': {
    background: theme.palette.figma_gray_middle_dark?.dark,
  },
}));

export const IconWrap = styled(Box, {
  shouldForwardProp: prop => prop !== 'active',
})<ActiveProps>(({theme, active}) => ({
  '.MuiSvgIcon-root': {
    transition: '0.2s',
    color: active ? theme.palette.figma_gray_dark_5?.main : 'inherit',
  },
}));

export const PlanText = styled(Typography, {
  shouldForwardProp: prop => prop !== 'active',
})<ActiveProps>(({theme, active}) => ({
  transition: '0.2s',
  color: active ? theme.palette.figma_gray_dark_5?.main : theme.palette.figma_gray_light_4?.main,
  fontSize: '14px',
  fontWeight: 400,
  lineHeight: '16px',
}));

interface HelpButtonProps extends ActiveProps {
  boxHover: boolean;
}

export const HelpButton = styled(Button, {
  shouldForwardProp: prop => prop !== 'active' && prop !== 'boxHover',
})<HelpButtonProps>(({theme, active, boxHover}) => ({
  padding: 0,
  minWidth: 'unset',
  background: 'none',

  '&:hover': {
    background: 'none',
  },

  '.MuiSvgIcon-root': {
    transition: '0.2s',
    transform: `scale(${boxHover || active ? '1.25' : '1'})`,
    color: active
      ? theme.palette.figma_primary?.light
      : boxHover
        ? theme.palette.figma_gray_light_4?.main
        : theme.palette.figma_surface_muted?.main,
  },
}));
